import React from "react";

import "./Success.css";
import { useLocation, useNavigate } from "react-router-dom";
const Success = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const packageName = location.state?.packageName || "ZikRme Dream Vacation";

  const email = location.state?.email || "user@email.com";
 
const date = location.state?.date || "Not Selected";
const amount = location.state?.amount || "0";
  return (
    <div className="success-container">
      <div className="success-box">
        <div className="checkmark-wrapper">
          <div className="checkmark"></div>
        </div>

        <h1 className="success-title">Booking Confirmed!</h1>

        <p className="success-text">
          Your trip to<strong> {packageName}</strong> is all set. We've sent the confirmation
          details to your email <strong>{email}.</strong>
        </p>
        <p>
          <strong>Booking ID:</strong>#ZKR-12345678
        </p>
        <p>
          <strong>Details Summary:</strong>
        </p>
        <p> Date: {date}</p>
        <p>Total Amount: ₹{amount} (Paid)</p>
        <div className="success-btn-div">
          <button className="home-btn" onClick={() => navigate("/")}>
            View My Bookings
          </button>

          <button className="home-btn" onClick={() => navigate("/")}>
            Download Receipt
          </button>
        </div>
      </div>
    </div>
  );
};

export default Success;
